module.exports = "<div>\r\n  <div class=\"case-container\">\r\n    <div s-if=\"showLoading==true\" style=\"margin-top: 30px;text-align: center\"><img style=\"width: 62px;height: 62px\"\r\n        src=\"" + require("../assets/img/loading.gif") + "\" alt=\"\"></div>\r\n    <div class=\"{{showCompany?'case-detail':'case-detail padding-30'}}\">\r\n      <div s-html=\"html\"></div>\r\n    </div>\r\n  </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/views/qjzxAnli.html
// module id = 373
// module chunks = 1